var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 40,
    rx: 4,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.073 20.194L13.212 16.333C11.692 17.99 11.116 19.65 11.106 19.684L11 20L11.105 20.316C11.127 20.383 13.421 27 21.054 27C21.983 27 22.829 26.898 23.606 26.727L20.86 23.981C19.8713 23.9325 18.936 23.518 18.236 22.818C17.536 22.118 17.1215 21.1827 17.073 20.194ZM21.054 13C19.199 13 17.679 13.404 16.412 13.998L12.707 10.293L11.293 11.707L29.293 29.707L30.707 28.293L27.409 24.995C30.047 23.042 30.988 20.358 31.002 20.316L31.107 20L31.002 19.684C30.98 19.617 28.687 13 21.054 13ZM22.96 20.546C23.147 19.869 22.988 19.107 22.468 18.586C21.948 18.065 21.185 17.907 20.508 18.094L19 16.586C19.618 16.206 20.3285 16.0032 21.054 16C23.26 16 25.054 17.794 25.054 20C25.051 20.7253 24.8479 21.4357 24.467 22.053L22.96 20.546Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEyeIcon);
export default __webpack_public_path__ + "static/media/hide-eye-icon.d1ec5ef2774481e3db6ec0659a8aa0c5.svg";
export { ForwardRef as ReactComponent };